import { addLocaleData } from "react-intl";

import cs from "react-intl/locale-data/cs";
import da from "react-intl/locale-data/da";
import de from "react-intl/locale-data/de";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import fr from "react-intl/locale-data/fr";
import hu from "react-intl/locale-data/hu";
import it from "react-intl/locale-data/it";
import ja from "react-intl/locale-data/ja";
import ko from "react-intl/locale-data/ko";
import ms from "react-intl/locale-data/ms";
import nl from "react-intl/locale-data/nl";
import pl from "react-intl/locale-data/pl";
import pt from "react-intl/locale-data/pt";
import ru from "react-intl/locale-data/ru";
import sk from "react-intl/locale-data/sk";
import th from "react-intl/locale-data/th";
import tr from "react-intl/locale-data/tr";
import vi from "react-intl/locale-data/vi";
import zh from "react-intl/locale-data/zh";

addLocaleData([
  ...cs,
  ...da,
  ...de,
  ...en,
  ...es,
  ...fr,
  ...hu,
  ...it,
  ...ja,
  ...ko,
  ...ms,
  ...nl,
  ...pl,
  ...pt,
  ...ru,
  ...sk,
  ...th,
  ...tr,
  ...vi,
  ...zh
]);

export const intlPolyfill = () => {
  if (!window.Intl) {
    require("intl");
    require("intl/locale-data/jsonp/cs");
    require("intl/locale-data/jsonp/da");
    require("intl/locale-data/jsonp/de");
    require("intl/locale-data/jsonp/en");
    require("intl/locale-data/jsonp/es");
    require("intl/locale-data/jsonp/fr");
    require("intl/locale-data/jsonp/hu");
    require("intl/locale-data/jsonp/it");
    require("intl/locale-data/jsonp/ja");
    require("intl/locale-data/jsonp/ko");
    require("intl/locale-data/jsonp/ms");
    require("intl/locale-data/jsonp/nl");
    require("intl/locale-data/jsonp/pl");
    require("intl/locale-data/jsonp/pt");
    require("intl/locale-data/jsonp/ru");
    require("intl/locale-data/jsonp/sk");
    require("intl/locale-data/jsonp/th");
    require("intl/locale-data/jsonp/tr");
    require("intl/locale-data/jsonp/vi");
    require("intl/locale-data/jsonp/zh");
  }
};
